module.exports = __webpack_public_path__ + "img/TECNOLOGIA-VITARA-2.47ee23ed.jpg";